import ATTRIBUTES from './attributes'
import MESSAGES from './messages'

export default {
  ATTRIBUTES,
  MESSAGES
}
